import { useCallback, useEffect, useState } from "react";
import {
  getRadarCalibrationState,
  parseCalibrationUrlFlag,
  setRadarCalibrationState,
  subscribeRadarCalibration,
} from "../utils/radarCalibrationStore.js";

export function useRadarCalibrationState() {
  const [state, setState] = useState(() => getRadarCalibrationState());

  useEffect(() => {
    if (parseCalibrationUrlFlag() && !state.active) {
      setRadarCalibrationState({ active: true, showBoundsOutline: true });
      setState(getRadarCalibrationState());
    }

    return subscribeRadarCalibration((next) => {
      setState(next);
    });
  }, []);

  const updateState = useCallback((patch) => {
    const result = setRadarCalibrationState(patch);
    if (result.ok) {
      setState(result.state);
    }
    return result;
  }, []);

  return [state, updateState];
}
